import AudienceGenderFilter from "../../components/filters/AudienceGenderFilter/AudienceGenderFilter";
import AudienceGenderFilterResult from "../../components/filters/AudienceGenderFilter/AudienceGenderFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindAudienceGenderFilter from "./AudienceGenderFilter";

export const audienceGenderSplitsDefinition = defineDescriptionFilter({
    key: "audienceGenderSplits",
    apiCategory: leadsFilterApiCategory.audienceGenderSplits,
    category: leadsFilterCategoryMap.trafficAndEngagement,
    trackingName: "Audience Gender",
    titleKey: { key: "si.lead_gen_filters.group.audience_gender.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.audienceGenderSplits.tooltip" },
        filter: new FindAudienceGenderFilter({
            options: description.audienceGenderSplits,
        }),
        filterView: AudienceGenderFilter,
        filterResultView: AudienceGenderFilterResult,
    }),
});
